import { ALL_INSTRUCTORS_OPTION, type InstructorOption } from './types';

export function getSelectedInstructorIds(
  instructors: Array<InstructorOption>,
): Array<string> {
  return instructors
    .filter((option) => option.value !== ALL_INSTRUCTORS_OPTION.value)
    .map((option) => option.value);
}
